import React from 'react';

const Contact = () => (
    <p>Contact</p>
);

export default Contact;